__turbopack_context__.v({
  "button": "Button-module__e7WGRa__button",
  "cookie": "Button-module__e7WGRa__cookie",
  "error": "Button-module__e7WGRa__error",
  "primary": "Button-module__e7WGRa__primary",
  "secondary": "Button-module__e7WGRa__secondary",
});
